import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ComponentNames } from '@core/const';
import { CategoriesMenuRootNodeIdService } from '@main/categories-menu/data-access';
import { CustomHamburgerMenuService } from '@main/categories-menu/feature';
import { MobileMenuFacade } from '@main/mobile-menu/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-open-mobile-categories',
  templateUrl: './open-mobile-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OpenMobileCategoriesComponent implements OnInit {
  iconType = CUSTOM_ICON_TYPE;
  isActive$: Observable<boolean>;
  rootNodeId$ = this.categoriesMenuRootNodeIdService.getRootNodeId();

  constructor(
    private mobileMenuFacade: MobileMenuFacade,
    private hamburgerMenuService: CustomHamburgerMenuService,
    private categoriesMenuRootNodeIdService: CategoriesMenuRootNodeIdService,
  ) {}

  ngOnInit(): void {
    this.categoriesMenuRootNodeIdService.loadRootNodeId();

    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      isMatch: this.mobileMenuFacade.isRootMatch(ComponentNames.CategoriesMenu),
    }).pipe(map(({ isExpanded, isMatch }) => isExpanded && isMatch));
  }

  toggleCatalog(): void {
    combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      isMatch: this.mobileMenuFacade.isRootMatch(ComponentNames.CategoriesMenu),
      rootNodeId: this.rootNodeId$,
    })
      .pipe(take(1))
      .subscribe(({ isExpanded, isMatch, rootNodeId }) => {
        if (isExpanded && isMatch) {
          this.mobileMenuFacade.resetSteps();

          return;
        }

        if (!isExpanded) {
          this.hamburgerMenuService.toggle();
        }

        this.mobileMenuFacade.openMobileMenu({
          componentName: ComponentNames.CategoriesMenu,
          headerTitle: 'Каталог',
          options: { nodeId: rootNodeId },
        });
      });
  }
}
